import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import AOIQueryUserResults from '@app/models/aoi-query-user-results';

import { LogService } from '@oa/shared-core';

@Injectable({
  providedIn: "root"
})
export class AOIService {
  private readonly _serviceName = 'AOIService';

  constructor(private http: HttpClient, private log: LogService) {}

  /**
   * Gets all of the AOI Query Results for a Query Request
   * aoi/query/results/{queryId:int}
   * @param queryId
   */
  public getAOIQueryRequests(queryId: number) {
    return this.http.get<AOIQueryUserResults>(`aoi/query/results/${queryId}`);
  }

  /**
   * Deletes query results
   * @param queryId 
   */
  public deleteQueryResults(queryId: number) {
    return this.http.delete(`aoi/query/${queryId}`);
  }
}
